import { defineComponent as _defineComponent } from 'vue'
import { computed, defineComponent } from 'vue';
import { typesOfIcon, sizes } from '../../constants/icon-constants';

interface IconWrapperProps {
  type: keyof typeof typesOfIcon;
  size?: keyof typeof sizes;
}
export default /*#__PURE__*/_defineComponent({
  __name: 'icon-wrapper',
  props: {
    type: null,
    size: { default: sizes.big }
  },
  setup(__props: any) {

const props = __props as { type: keyof typeof typesOfIcon, size: keyof typeof sizes };

;


const getTypeClass = computed(() => {
  return props.type ? `icon-wrapper--${props.type}` : '';
});

const getSizeClass = computed(() => {
  return props.size ? `icon-wrapper--${props.size}` : '';
});


return { __sfc: true,props, getTypeClass, getSizeClass }
}

})